import { useState } from 'react'
import { Input, Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem } from 'components'
import { validateEmail } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueEmail({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidateEmail = (email: string): boolean => {
    let initialValue = { isValid: true, message: '' }

    if (email && !validateEmail(email)) {
      initialValue = { isValid: false, message: 'Email está errado' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <Input
          type="email"
          {...formMethods.register('default_value', {
            validate: handleValidateEmail,
          })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
